<template>
  <div class="card" v-if="nuevoProducto">
    <!-- <CrudProveedor></CrudProveedor> -->
  </div>
  <ProductoCreate
    :mostrar="mostrarProductoModal"
    :producto="producto"
    @closeModal="cerrarModal"
    @actualizarListadoProductos="obtenerListadoProductos"
  ></ProductoCreate>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Par&aacute;metros</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Productos</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <router-link to="/productos" class="text-900 line-height-3"
        >Listado de Productos</router-link
      >
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Productos
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Producto Crear' in auth.user.permissions"
          class="p-button-outlined mr-2 p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Registrar Nuevo Producto'"
          @click="openModal"
          :disabled="!cargando ? false : true"
        ></Button>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtlaboratorios"
        dataKey="id"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 100, 500, 1000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Productos"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
        filterDisplay="menu"
        :value="productos"
        :loading="cargando"
        :paginator="true"
        :filters="buscar"
        :rows="20"
        :rowHover="true"
        :lazy="true"
        :totalRecords="totalRegistros"
        v-model:filters="buscar"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        selectionMode="single"
        @row-dblclick="editarProducto($event.data)"
      >
        <!-- <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar Producto..."
              />
            </span>
          </div>
        </template> -->
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column
          field="codigo_interno"
          header="COD.INT."
          style="font-size: 1em"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="COD.INT."
            />
          </template>
        </Column>
        <Column
          field="codigo_origen"
          header="COD.ORIG."
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
          style="width: 120px"
          :class="'text-right'"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="COD.ORIG."
            />
          </template>
        </Column>
        <Column
          field="descripcion"
          header="DESCRIPCIÓN/DETALLE"
          filterMatchMode="contains"
          :showFilterMatchModes="false"
          style="width: 500px"
          :bodyStyle="{
            'font-size': '0.8rem',
            'font-weight': 'bold',
            width: '500px',
          }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="DESCRIPCIÓN..."
            />
          </template>
        </Column>
        <Column
          field="medidas"
          header="DIMENSIONES"
          style="font-size: 1em"
        ></Column>
        <Column
          field="procedencia_nombre"
          header="PROC."
          style="font-size: 1em"
        ></Column>
        <Column
          field="fabricas.nombre"
          header="MARCA"
          filterMatchMode="contains"
          :showFilterMatchModes="false"
          style="font-size: 1em"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="MARCA..."
            /> </template
        ></Column>
        <Column
          field="unidad_medida_nombre"
          header="U.MEDIDA"
          style="font-size: 1em"
        >
          {{ data.unidad_medida_nombre }}
        </Column>
        <!-- <Column
          field="stock_minimo"
          header="STOCK.MIN."
          class="text-right"
        ></Column> -->
        <Column
          field="precio_sugerido"
          header="P.VENTA"
          style="font-size: 1em"
        ></Column>
        <Column field="estado" header="ESTADO" style="font-size: 1em">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado.value]">
              {{ data.estado.label }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES" style="font-size: 1em">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      v-model:visible="deleteProdModal"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="producto"
          >Estas Seguro que quieres eliminar producto:
          <b>{{ producto.descripcion }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="deleteProdModal = false"
        />
        <Button
          label="Si"
          icon="pi pi-check"
          class="p-button-primary"
          @click="deleteProducto"
        />
      </template>
    </Dialog>

    <ProductoImagenes
      :show="verImagenes"
      :producto_id="ProductoImagenes"
      @closeModal="ocultarDialog"
      @actualizarListado="obtenerListadoProductos"
    ></ProductoImagenes>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "@/service/ProductService";
import ProductoCreate from "@/module/productos/ProductoCreate.vue";
import ProductoImagenes from "@/module/productos/ProductoImagenes.vue";
import { useAuth } from "@/stores";
//nuevo o editar
export default {
  components: { ProductoImagenes, ProductoCreate },
  data() {
    return {
      nuevoProducto: false,
      totalRegistros: 0,
      productos: [],
      cargando: true,
      mostrarProductoModal: false,
      producto: {},
      deleteProdModal: false,
      buscar: null,
      lazyParams: {},
      claseEstado: ["status-outofstock", "status-instock"],
      verImagenes: false,
      ProductoImagenes: null,
    };
  },
  productoService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.productoService = new ProductService();
    this.initBuscar();
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dtlaboratorios.rows,
      sortField: null,
      sortOrder: null,
      filters: this.buscar,
    };
    this.obtenerListadoProductos();
  },
  methods: {
    onPage(event) {
      this.lazyParams = event;
      this.obtenerListadoProductos();
    },
    onSort(event) {
      this.lazyParams = event;
    },
    onFilter() {
      this.lazyParams.filters = this.buscar;
      this.obtenerListadoProductos();
    },
    ocultarDialog() {
      this.verImagenes = false;
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Producto Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarProducto(datos);
          },
        },
        {
          label: "Ver Detalle",
          disabled:
            "Producto Ver Detalle" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-eye",
          command: () => {
            this.verDetalle(datos);
          },
        },
        {
          label: "Ver Imagenes",
          icon: "pi pi-image",
          command: () => {
            this.mostrar_imagenes(datos.id);
          },
        },
        {
          label: "Eliminar",
          disabled: "Producto Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteProducto(datos);
          },
        },
      ];
    },
    mostrar_imagenes(producto_id) {
      this.ProductoImagenes = producto_id;
      this.verImagenes = true;
    },
    openModal() {
      this.producto = {
        estado: { label: "Activo", value: 1 },
        stock_minimo: 0,
        stock_maximo: 0,
        precio_sugerido: 0,
      };
      this.mostrarProductoModal = true;
    },
    cerrarModal() {
      this.mostrarProductoModal = false;
      this.producto = {};
    },
    obtenerListadoProductos() {
      this.cargando = true;
      setTimeout(() => {
        this.productoService
          .getAllProductos({ dt_params: JSON.stringify(this.lazyParams) })
          .then((data) => {
            this.totalRegistros = data.productos.total;
            this.productos = data.productos.data;
            this.cargando = false;
            this.productos.forEach((producto) => {
              producto.created_at = new Date(producto.created_at);
              producto.updated_at = new Date(producto.updated_at);
              producto.estado = {
                label: this.textoEstado(producto.estado),
                value: producto.estado,
              };
            });
          });
      }, Math.random() * 1000 + 250);
    },
    textoEstado(estado) {
      return estado == 1 ? "Activo" : "Inactivo";
    },
    editarProducto(info_producto) {
      this.producto = { ...info_producto };
      this.producto.stock_minimo = parseInt(this.producto.stock_minimo);
      this.producto.stock_maximo = parseInt(this.producto.stock_maximo);
      this.producto.precio_sugerido = parseFloat(this.producto.precio_sugerido);
      this.producto.precio_almacen = parseFloat(this.producto.precio_almacen);
      this.producto.stock_actual = parseInt(this.producto.stock_actual);
      this.producto.precio_venta = parseFloat(this.producto.precio_venta);
      this.producto.precio_compra = parseFloat(this.producto.precio_compra);
      this.mostrarProductoModal = true;
    },
    verDetalle(producto) {
      this.$router.push(`/producto/${producto.id}/detalle`);
    },
    confirmDeleteProducto(producto) {
      this.producto = { ...producto };
      this.deleteProdModal = true;
    },
    deleteProducto() {
      this.productoService.deleteProducto(this.producto).then((response) => {
        this.productos = this.productos.filter(
          (val) => val.id !== this.producto.id
        );
        this.deleteProdModal = false;
        this.producto = {};

        this.$toast.add({
          severity: "success",
          summary: "Exito",
          detail: response.mensaje,
          life: 3000,
        });
      });
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.EQUALS },
        codigo_origen: { value: null, matchMode: FilterMatchMode.CONTAINS },
        descripcion: { value: null, matchMode: FilterMatchMode.CONTAINS },
        codigo_interno: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "fabricas.nombre": { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}
</style>
